import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAMLSCommonAlertDetails } from '../../../redux/actions/common';
import AlertTopPanelDetails from './AlertTopPanelDetails';

function mapStateToProps(state) {
  const { alertDetails = {} } = state.amlsCommon;
  const { data, error, isLoading } = alertDetails;

  return {
    alertDetails: data,
    error,
    isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators({ getAMLSCommonAlertDetails }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertTopPanelDetails);
